/**
 * 개발자 모드 스토어 — 개발/시연용 기능(데모 모드·QuickRun 등)의 단일 게이트.
 *
 * 설정 페이지 스위치로 켜고 끄며 브라우저(localStorage)별로 기억된다 —
 * 켠 사람의 브라우저에만 영향이라 서버 작업이 없고, 끄는 걸 잊어도 다른
 * 사용자에게 노출되지 않는다. 배포 env 플래그(예: VITE_ENABLE_QUICKRUN)와는
 * "또는" 관계: 로컬 개발은 env로 항상 켜고, 배포는 이 스위치로만 연다.
 */

import { create } from 'zustand';
import { persist } from 'zustand/middleware';

interface DevModeState {
  devMode: boolean;
  setDevMode: (on: boolean) => void;
}

export const useDevModeStore = create<DevModeState>()(
  persist(
    (set) => ({
      devMode: false,
      setDevMode: (on) => set({ devMode: on }),
    }),
    { name: 'vsmr-dev-mode' },
  ),
);
